import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import LevelManagement from "../../components/Security/LevelManagement/LevelManagement";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const LevelManagementPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>User Level Management</VolunteerHeading>
      <LevelManagement />
    </MainDiv>
  );
};

export default LevelManagementPage;
